export default __webpack_public_path__ + "static/media/adtoi.8ebbbf3c.svg";